import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const EmptyServicePlaceholder = ({ text }) => (
  <div className="empty-service-placeholder">{text}</div>
);

EmptyServicePlaceholder.propTypes = {
  text: PropTypes.string.isRequired,
};

export default EmptyServicePlaceholder;
